import { PanelLeftClose, PanelRightClose } from "lucide-react";
import React from "react";
import { IconButton } from "../../../ui/IconButton";
import { EditorSide, usePanelLayout } from "./EditorLayoutContext";

/** Header action that collapses the sidebar a panel lives in. */
export const PanelCollapseButton: React.FC<{ side: EditorSide }> = ({
  side
}) => {
  const { setSideCollapsed } = usePanelLayout();
  const Icon = side === "left" ? PanelLeftClose : PanelRightClose;
  return (
    <IconButton
      label={side === "left" ? "Collapse sidebar" : "Collapse inspector"}
      size="sm"
      onClick={() => setSideCollapsed(side, true)}
    >
      <Icon size={15} />
    </IconButton>
  );
};
